import { useState, useEffect, useRef, useCallback } from "react";
import Layout from "../Component/Layout";
import { BarChart, Bar, LineChart, Line, PieChart, Pie, AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from "recharts";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import PropTypes from "prop-types";
import { ORDER_API } from "../apiConfig";

const SalesOrderDashboard = () => {

  //   Filters
  // const [division, setDivision] = useState("");
  const [customer, setCustomer] = useState("");
  const [distribution, setDistribution] = useState("");
  // const [productGroup, setProductGroup] = useState("");
  const [productCode, setProductCode] = useState("");
  const [status, setStatus] = useState([]);
  const [salesOrganisation, setSalesOrganisation] = useState("");
  const [customerSegment, setCustomerSegment] = useState("");
  // const [enquiryType, setEnquiryType] = useState("");

  //   Date filters
  const [year, setYear] = useState("");
  const [month, setMonth] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  //   refs for calendar
  const fromRef = useRef(null);
  const toRef = useRef(null);

  //   Dropdown data
  // const [divisionList, setDivisionList] = useState([]);
  const [customerList, setCustomerList] = useState([]);
  const [distributionList, setDistributionList] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [productCodeList, setProductCodeList] = useState([]);
  // const [productGroupList, setProductGroupList] = useState([]);
  const [salesOrganisationList, setSalesOrganisationList] = useState([]);
  const [customerSegmentList, setCustomerSegmentList] = useState([]);
  // const [enquiryTypeList, setEnquiryTypeList] = useState([]);


  const navigate = useNavigate();
  const [tableData, setTableData] = useState([]);
  const [viewType, setViewType] = useState("table");
  const [yearList, setYearList] = useState([]);
  const [chartType, setChartType] = useState("bar");
  const [selectedTile, setSelectedTile] = useState(null);
  const [toast, setToast] = useState({ show: false, message: "", type: "error" });
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

 useEffect(() => {
  fetch(`${ORDER_API}/salesdashboard/filters`)
    .then(res => res.json())
    .then(res => {
  const data = res.data || {};

  setCustomerList(data.customer || []);
  setDistributionList(data.distribution_channel || []);
  setProductCodeList(data.product_code || []);
  setYearList(data.year || []);

  setSalesOrganisationList(data.sales_organisation || []);
  setCustomerSegmentList(data.customer_segment || []);

  // Temporarily remove enquiry type
  // setEnquiryTypeList([]);
})
    .catch(err => console.error(err));
}, []);

  const styles = {
    tableContainer: {
      background: "#ffffff",
      borderRadius: 8,
      padding: 12,
      boxShadow: "0 1px 4px rgba(0,0,0,0.08)"
    },
    erpTable: {
      width: "100%",
      tableLayout: "auto",
      borderCollapse: "collapse"
    },
    erpTh: {
      background: "#f8fafc",
      fontSize: 13,
      fontWeight: 600,
      padding: "10px 12px",
      borderBottom: "1px solid #e5e7eb",
      color: "#1e293b",
      whiteSpace: "nowrap"
    },
    erpTd: {
      fontSize: 13,
      padding: "10px 12px",
      borderBottom: "1px solid #f1f5f9",
      color: "#334155",
      verticalAlign: "middle"
    }
  };


 const customSelectStyles = {
  control: (base) => ({
    ...base,
    minHeight: 32,
    height: 32,
    fontSize: "12.5px",
  }),
  valueContainer: (base) => ({
    ...base,
    minHeight: "32px",
    padding: "0 6px",
    flexWrap: "wrap"
  }),
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: 3
  }),
  clearIndicator: (base) => ({
    ...base,
    padding: 3
  }),
  indicatorsContainer: (base) => ({
    ...base,
    height: "32px"
  }),
  menu: (base) => ({
    ...base,
    zIndex: 9999,
    fontSize: "13px"
  }),
  menuList: (base) => ({
    ...base,
    maxHeight: "180px"
  }),
  option: (base) => ({
    ...base,
    whiteSpace: "normal",
    wordBreak: "break-word",
    fontSize: "13px"
  }),
  singleValue: (base) => ({
    ...base,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  }),
  multiValue: (base) => ({ ...base }),
  multiValueLabel: (base) => ({ ...base })
};

const headingStyle = {
  margin: "0 0 8px 0",
  color: "#0f172a",
  fontWeight: "700",
  fontSize: "32px"
};

const labelStyle = {
  fontSize: "12px",
  fontWeight: 500,
  color: "#374151",
};

const inputStyle = {
  fontSize: "14px",
};

const tableHeaderStyle = {
  fontSize: "14px",
  fontWeight: 600,
  color: "#000",
};

const tableCellStyle = {
  fontSize: "14px",
  color: "#000",
};


  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;

      return (
        <div
          style={{
            background: "#fff",
            padding: "10px",
            border: "1px solid #ddd",
            borderRadius: "8px",
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)"
          }}
        >
          <div style={{ fontWeight: "600", marginBottom: "5px" }}>
            {data.name}
          </div>

          <div style={{ fontSize: "13px", color: "#334155" }}>
            Count: <b>{data.value}</b>
          </div>

          <div style={{ fontSize: "13px", color: "#334155" }}>
            Amount: <b>₹ {formatCurrency(data.netPrice)}</b>
          </div>
        </div>
      );
    }

    return null;
  };

  CustomTooltip.propTypes = {
    active: PropTypes.bool,
    payload: PropTypes.array,
    label: PropTypes.any
  };

  //   Handle changes (clear logic)
  const handleYearChange = (val) => {
    setYear(val);
    setMonth("");
    setFromDate("");
    setToDate("");
  };

  const handleMonthChange = (val) => {
    setMonth(val);
    setFromDate("");
    setToDate("");
  };

  const handleFromDateChange = (val) => {
    setFromDate(val);
    setYear("");
    setMonth("");
  };

  const handleToDateChange = (val) => {
    setToDate(val);
    setYear("");
    setMonth("");
  };

  const formatOptions = (list) =>
    list.map(item => ({ value: item, label: item }));

  const [tileData, setTileData] = useState({
    totalSales: 0,
    openSales: 0
  });

  const handleGenerate = useCallback(() => {

    setCurrentPage(1);

   let queryObj = {
  customer,
  product_code: productCode,
  sales_organisation: salesOrganisation,
  customer_segment: customerSegment,
  distribution_channel: distribution,
  // enquiry_type: enquiryType
};
    //   Date filters
    if (fromDate && toDate) {
      queryObj.fromDate = fromDate;
      queryObj.toDate = toDate;
    } else {
      if (year) queryObj.year = year;
      if (month) queryObj.month = month;
    }

    //   NEW: Add dropdown filters
    
    if (customer) queryObj.customer = customer;
    if (distribution) queryObj.distribution_channel = distribution;
    if (productCode) queryObj.product_code = productCode;
    if (salesOrganisation) queryObj.sales_organisation = salesOrganisation;
    if (customerSegment) queryObj.customer_segment = customerSegment;
    // if (enquiryType) queryObj.enquiry_type = enquiryType;
    if (Array.isArray(status) && status.length > 0) {
      queryObj.status = status.map(s => s.value).join(",");
    }

    const query = new URLSearchParams(queryObj).toString();
// Tiles
fetch(`${ORDER_API}/salesdashboard/tiles?${query}`)
  .then(res => res.json())
  .then(res => setTileData(res.data || res));

fetch(`${ORDER_API}/salesdashboard/orders?${query}`)
  .then(res => res.json())
  .then(res => setTableData(res.data || res));

  }, [
    year,
    month,
    fromDate,
    toDate,
    customer,
    distribution,
    productCode,
    salesOrganisation,
    customerSegment,
    // enquiryType,
    status
  ]);

  //   INITIAL LOAD (no filters → full data)
  const fetchDefaultTiles = () => {
  setCurrentPage(1);

  fetch(`${ORDER_API}/salesdashboard/tiles`)
    .then(res => res.json())
    .then(res => setTileData(res.data || res))
    .catch(err => console.error(err));

  fetch(`${ORDER_API}/salesdashboard/orders`)
    .then(res => res.json())
    .then(res => setTableData(res.data || res))
    .catch(err => console.error(err));
};

useEffect(() => {
  fetchDefaultTiles();
}, []);

const isFirstLoad = useRef(true);

useEffect(() => {
  if (isFirstLoad.current) {
    isFirstLoad.current = false;
    return;
  }

  const noFilters =
    !year &&
    !month &&
    !fromDate &&
    !toDate &&
    !customer &&
    !distribution &&
    !productCode &&
    !salesOrganisation &&
    !customerSegment &&
    // !enquiryType &&
    Array.isArray(status) &&
    status.length === 0;

  if (noFilters && !selectedTile) {
    fetchDefaultTiles();
  } else if (!selectedTile) {
    handleGenerate();
  }
}, [
  year,
  month,
  fromDate,
  toDate,
  customer,
  distribution,
  productCode,
  salesOrganisation,
  customerSegment,
  // enquiryType,
  status,
  selectedTile,
  handleGenerate
]);

const handleReset = () => {
  setYear("");
  setMonth("");
  setFromDate("");
  setToDate("");
  // setDivision("");
  setCustomer("");
  setDistribution("");
  // setProductGroup("");
  setSalesOrganisation("");
  setCustomerSegment("");
  // setEnquiryType("");
  setProductCode("");
  setStatus([]);
  setSelectedTile(null);
  fetchDefaultTiles();
};

const chartColorMap = {
  "Total": "#2563eb",
  "Open": "#16a34a",
  "Billed": "#f97316",
  "Approved": "#10b981",
  "Partially Approved": "#10b981",
  "Rejected": "#dc2626",
  "Planning Released": "#9333ea",
  "Planning Blocked": "#b91c1c",
  "Production": "#4f46e5",
  "Stock": "#14b8a6",
  "Cancelled": "#ef4444"
};

  const chartData = [
  { name: "Total", value: tileData.totalSales, netPrice: tileData.totalSalesValue },
  { name: "Open", value: tileData.openSales, netPrice: tileData.openSalesValue },
  { name: "Billed", value: tileData.billed, netPrice: tileData.billedValue },
  { name: "Approved", value: tileData.approved, netPrice: tileData.approvedValue },
  { name: "Partially Approved", value: tileData.partiallyApproved, netPrice: tileData.partiallyApprovedValue },
  { name: "Rejected", value: tileData.rejected, netPrice: tileData.rejectedValue },
  { name: "Planning Released", value: tileData.planningReleased, netPrice: tileData.planningReleasedValue },
  { name: "Planning Blocked", value: tileData.planningBlocked, netPrice: tileData.planningBlockedValue },
  { name: "Production", value: tileData.inProduction, netPrice: tileData.inProductionValue },
  { name: "Stock", value: tileData.inStock, netPrice: tileData.inStockValue },
  { name: "Cancelled", value: tileData.cancelled, netPrice: tileData.cancelledValue }
];

  const showToast = (message, type = "error") => {
    setToast({ show: true, message, type });

    setTimeout(() => {
      setToast({ show: false, message: "", type: "error" });
    }, 3000);
  };

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = tableData.slice(indexOfFirstRow, indexOfLastRow);

  const totalPages = Math.ceil(tableData.length / rowsPerPage);

  const handleExport = () => {

    if (!tableData || tableData.length === 0) {
      showToast("No data to export", "error");
      return;
    }

    const formatDate = (date) => {
      if (!date) return "";
      return new Date(date)
        .toLocaleDateString("en-GB")
        .replace(/\//g, "-");
    };

    //   Convert all fields dynamically
    const exportData = tableData.map(row => {
      let newRow = {};

      Object.keys(row).forEach(key => {
        let value = row[key];

        //   Format dates
        if (key.toLowerCase().includes("date")) {
          value = formatDate(value);
        }

        newRow[key] = value;
      });

      return newRow;
    });

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Sales Orders");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array"
    });

    const data = new Blob([excelBuffer], {
      type: "application/octet-stream"
    });

    saveAs(data, "sales_orders.xlsx");
    showToast("Export successful", "success");
  };

  const formatCurrency = (value) => {
    if (!value) return "0";

    const num = Number(value);

    if (num >= 10000000) {
      // Crore
      return (num / 10000000).toFixed(2) + " Cr";
    } else if (num >= 100000) {
      // Lakh
      return (num / 100000).toFixed(2) + " Lakh";
    } else {
      // Below lakh
      return num.toLocaleString("en-IN");
    }
  };


  const fetchTableData = (tileType = null) => {
    setCurrentPage(1);

    let queryObj = {
      customer,
      product_code: productCode,
      sales_organisation: salesOrganisation,
      customer_segment: customerSegment,
      distribution_channel: distribution,
      // enquiry_type: enquiryType
    };

    if (fromDate && toDate) {
      queryObj.fromDate = fromDate;
      queryObj.toDate = toDate;
    } else {
      if (year) queryObj.year = year;
      if (month) queryObj.month = month;
    }

    if (tileType) {
      queryObj.tile = tileType;   //   KEY
    }

    const query = new URLSearchParams(queryObj).toString();

    fetch(`${ORDER_API}/salesdashboard/orders?${query}`)
      .then(res => res.json())
      .then(res => setTableData(res.data || res));
  };
  return (
    <Layout defaultSidebarOpen={false}>
      <div className="dashboard-container">

        {/* ================= HEADER + DATE FILTERS ================= */}
<div
  className="d-flex justify-content-between align-items-end flex-wrap gap-3"
  style={{ marginBottom: "24px" }}
>
  <div>
    <h2 style={headingStyle}>Sales Order Dashboard</h2>
    <p style={{ fontSize: "13px", color: "#6b7280", margin: 0 }}>
      Track your SalesOrder Status and Conversions
    </p>
  </div>

  <div className="d-flex align-items-end gap-2 flex-wrap">
    <div>
      <label className="form-label" style={labelStyle}>Year</label>
      <select
        className="form-select form-select-sm"
        style={{ ...inputStyle, width: "90px" }}
        value={year}
        onChange={(e) => handleYearChange(e.target.value)}
        disabled={fromDate || toDate}
      >
        <option value="">All</option>
        {yearList.map((yr, index) => (
          <option key={index} value={yr}>{yr}</option>
        ))}
      </select>
    </div>

    <div>
      <label className="form-label" style={labelStyle}>Month</label>
      <select
        className="form-select form-select-sm"
        style={{ ...inputStyle, width: "110px" }}
        value={month}
        onChange={(e) => handleMonthChange(e.target.value)}
        disabled={fromDate || toDate}
      >
        <option value="">All</option>
        <option value="1">Jan</option>
        <option value="2">Feb</option>
        <option value="3">Mar</option>
        <option value="4">Apr</option>
        <option value="5">May</option>
        <option value="6">Jun</option>
        <option value="7">Jul</option>
        <option value="8">Aug</option>
        <option value="9">Sep</option>
        <option value="10">Oct</option>
        <option value="11">Nov</option>
        <option value="12">Dec</option>
      </select>
    </div>

    <div>
      <label className="form-label" style={labelStyle}>From</label>
      <input
        type="date"
        className="form-control form-control-sm"
        style={{ ...inputStyle, width: "135px" }}
        ref={fromRef}
        value={fromDate}
        onChange={(e) => handleFromDateChange(e.target.value)}
        disabled={year || month}
      />
    </div>

    <div>
      <label className="form-label" style={labelStyle}>To</label>
      <input
        type="date"
        className="form-control form-control-sm"
        style={{ ...inputStyle, width: "135px" }}
        ref={toRef}
        value={toDate}
        onChange={(e) => handleToDateChange(e.target.value)}
        disabled={year || month}
      />
    </div>

    <button
      className="btn btn-sm"
      style={{
        background: "#0047AB",
        color: "#fff",
        border: "1px solid #0047AB",
        fontWeight: 500
      }}
      onClick={handleReset}
    >
      Reset
    </button>
  </div>
</div>

        {/* ================= ADV FILTER ================= */}
<div className="d-flex flex-wrap gap-2 mt-2 mb-3">
  {[
    { label: "Product Code", value: productCode, setValue: setProductCode, options: productCodeList, width: 170 },
    { label: "Customer", value: customer, setValue: setCustomer, options: formatOptions(customerList), width: 170 },
    { label: "Sales Organisation", value: salesOrganisation, setValue: setSalesOrganisation, options: formatOptions(salesOrganisationList), width: 150 },
    { label: "Customer Segment", value: customerSegment, setValue: setCustomerSegment, options: formatOptions(customerSegmentList), width: 150 },
    { label: "Distribution Channel", value: distribution, setValue: setDistribution, options: formatOptions(distributionList), width: 160 }
  ].map((f, i) => {
    const selectedOption =
      f.options.find(o => o.value === f.value) || null;

    return (
      <div key={i} style={{ width: f.width }} title={selectedOption?.label || ""}>
        <label className="form-label" style={labelStyle}>
          {f.label}
        </label>
        <Select
          styles={customSelectStyles}
          options={f.options}
          value={selectedOption}
          onChange={(s) => f.setValue(s ? s.value : "")}
          isClearable
        />
      </div>
    );
  })}
</div>

        {/* ================= TILES ================= */}
<div className="d-flex flex-wrap gap-2 mt-2">
  {[
    { title: "Total Sales Order", value: tileData.totalSales, amount: tileData.totalSalesValue, color: "#2563eb" },
    { title: "Open Sales Order", value: tileData.openSales, amount: tileData.openSalesValue, color: "#16a34a" },
    { title: "Billed", value: tileData.billed, amount: tileData.billedValue, color: "#f97316" },
    { title: "Approved", value: tileData.approved, amount: tileData.approvedValue, color: "#10b981" },
    { title: "Partially Approved", value: tileData.partiallyApproved, amount: tileData.partiallyApprovedValue, color: "#10b981" },
    { title: "Rejected", value: tileData.rejected, amount: tileData.rejectedValue, color: "#dc2626" },
    { title: "Planning Released", value: tileData.planningReleased, amount: tileData.planningReleasedValue, color: "#9333ea" },
    { title: "Planning Blocked", value: tileData.planningBlocked, amount: tileData.planningBlockedValue, color: "#b91c1c" },
    { title: "In Production", value: tileData.inProduction, amount: tileData.inProductionValue, color: "#4f46e5" },
    { title: "In Stock", value: tileData.inStock, amount: tileData.inStockValue, color: "#14b8a6" },
    { title: "Cancelled", value: tileData.cancelled, amount: tileData.cancelledValue, color: "#ef4444" }
  ].map((tile, index) => (
    <div
      key={index}
      style={{ width: "170px" }}
      title={tile.title}
      onClick={() => {
        const title = tile.title;
        if (title === "Total Sales Order") {
          setSelectedTile(null);
          setStatus([{ label: "Total Sales Order", value: "Total Sales Order" }]);
          fetchTableData();
          return;
        }
        setSelectedTile(title);
        setStatus([{ label: title, value: title }]);
        fetchTableData(title);
      }}
    >
      <div
        style={{
          background: "#f3f4f6",
          borderRadius: "10px",
          padding: "8px 10px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          boxShadow: "0 4px 10px rgba(0,0,0,0.06)",
          borderLeft: `4px solid ${tile.color}`,
          transition: "all 0.2s ease",
          cursor: "pointer"
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "translateY(-3px)";
          e.currentTarget.style.boxShadow = "0 8px 16px rgba(0,0,0,0.12)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "0 4px 10px rgba(0,0,0,0.06)";
        }}
      >
        <div style={{
          fontSize: "12.5px",
          fontWeight: 600,
          color: "#374151",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        }}>
          {tile.title}
        </div>

        <div style={{ fontSize: "16px", fontWeight: 700, color: "#000", marginTop: "2px" }}>
          {tile.value || 0}
        </div>

        <div style={{ fontSize: "12.5px", fontWeight: 600, color: "#000", marginTop: "2px", textAlign: "right" }}>
          ₹ {formatCurrency(tile.amount)}
        </div>
      </div>
    </div>
  ))}
</div>

        <div className="mt-4">
          <div className="d-flex justify-content-between align-items-center mb-2">
            {/* LEFT */}
            <div className="btn-group">
              <button
                className="btn btn-sm"
                style={{
                  backgroundColor: viewType === "table" ? "#0047AB" : "white",
                  color: viewType === "table" ? "white" : "#0047AB",
                  border: "1px solid #0047AB",
                  fontSize: "13px",
                  fontWeight: 500
                }}
                onClick={() => setViewType("table")}>
                Table
              </button>
              <button
                className="btn btn-sm"
                style={{
                  backgroundColor: viewType === "graph" ? "#0047AB" : "white",
                  color: viewType === "graph" ? "white" : "#0047AB",
                  border: "1px solid #0047AB",
                  fontSize: "13px",
                  fontWeight: 500
                }}
                onClick={() => setViewType("graph")}>
                Graph
              </button>
            </div>
            {/* RIGHT - Status + Export */}
            <div className="d-flex align-items-center gap-2 flex-nowrap">

              {/* STATUS */}
              <div
  style={{ width: "220px" }}
  title={status.length ? status.map(s => s.label).join(", ") : ""}
>
                <Select
                  styles={customSelectStyles}
                  options={[
                    ...formatOptions(statusList),
                    { label: "Total Sales Order", value: "Total Sales Order" },
                    { label: "Open Sales Order", value: "Open Sales Order" },
                    { label: "Billed", value: "Billed" },
                    { label: "Planning Released", value: "Planning Released" },
                    { label: "Planning Blocked", value: "Planning Blocked" },
                    { label: "In Production", value: "In Production" },
                    { label: "In Stock", value: "In Stock" },
                    { label: "Cancelled", value: "Cancelled" },
                    { label: "Partially Approved", value: "Partially Approved" },
                    { label: "Partially Rejected", value: "Partially Rejected" },
                    // { label: "Partially Cancelled", value: "Partially Cancelled" }
                    { label: "Approved", value: "Approved" },
                    { label: "Rejected", value: "Rejected" }
                  ]}
                  value={status}
                  onChange={(selected) => {
                    setStatus(selected || []);
                    setSelectedTile(null);
                  }}
                  isMulti
                  isClearable
                  placeholder="Select Status"
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                  // styles={{
                  //   control: (base) => ({
                  //     ...base,
                  //     minHeight: "38px",
                  //     borderRadius: "8px"
                  //   }),
                  //   menuPortal: (base) => ({ ...base, zIndex: 9999 })
                  // }} 
                  />
              </div>

              {/* EXPORT */}
              {viewType === "table" && (
                <button
                  onClick={handleExport}
                  className="btn btn-sm text-white"
                  style={{
                    background: "#0047AB",
                    color: "#fff",
                    border: "1px solid #0047AB",
                    fontSize: "13px",
                    fontWeight: 500
                  }}>
                  Export
                </button>
              )}
            </div>
          </div>

          {/*   CONTENT CARD */}

          <div
            style={{
              background: "#ffffff", borderRadius: "12px", padding: "16px", boxShadow: "0 2px 8px rgba(0,0,0,0.08)", marginTop: "10px"
            }}>
            {/*   GRAPH */}
            {viewType === "graph" && (
              <div>
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <div style={{ marginBottom: "10px", marginTop: "5px", fontSize: "16px", fontWeight: "600", color: "#1e293b" }}>
                    SO Status Overview
                  </div>
                  <select
                    className="form-select form-select-sm"
                    style={{ width: "150px" }}
                    value={chartType}
                    onChange={(e) => setChartType(e.target.value)} >
                    <option value="bar">Bar Chart</option>
                    <option value="line">Line Chart</option>
                    <option value="pie">Pie Chart</option>
                    <option value="area">Area Chart</option>
                  </select>

                </div>


                <div style={{ width: "100%", height: "320px", marginTop: "10px" }}>
                  <ResponsiveContainer>

                    {/*   BAR CHART (with your colors preserved) */}
                    {chartType === "bar" && (
                      <BarChart data={chartData} barCategoryGap="10%" barGap={2} margin={{ top: 10, right: 40, left: 10, bottom: 10 }}>
                        <CartesianGrid vertical={false} stroke="#e5e7eb" />
                        <XAxis dataKey="name" interval={0} angle={-20} textAnchor="end" height={50} />
                        <YAxis />
                        <Tooltip content={<CustomTooltip />} />
                        <Bar dataKey="value" barSize={40} radius={[10, 10, 0, 0]}>
                          {chartData.map((entry, index) => (
                            <Cell
                              key={`cell-${index}`}
                              fill={chartColorMap[entry.name]}
                            />
                          ))}
                        </Bar>
                      </BarChart>
                    )}

                    {/*   LINE */}
                    {chartType === "line" && (
                      <LineChart data={chartData} margin={{ top: 10, right: 40, left: 10, bottom: 10 }}>
                        <CartesianGrid vertical={false} stroke="#e5e7eb" />
                        <XAxis
                          dataKey="name"
                          interval={0}
                          angle={-20}
                          textAnchor="end"
                          height={50}
                        />
                        <YAxis />
                        <Tooltip content={<CustomTooltip />} />
                        <Line type="monotone" dataKey="value" stroke="#2563eb" />
                      </LineChart>
                    )}

                    {/*   PIE */}
{chartType === "pie" && (
  <PieChart>
    <Tooltip
      content={({ active, payload }) => {
        if (active && payload && payload.length) {
          const data = payload[0].payload;

          return (
            <div
              style={{
                background: "#fff",
                padding: "10px",
                border: "1px solid #ddd",
                borderRadius: "8px"
              }}
            >
              <div><b>{data.name}</b></div>
              <div>Count: {data.value}</div>
              <div>Amount: ₹ {formatCurrency(data.netPrice)}</div>
            </div>
          );
        }
        return null;
      }}
    />
    <Pie
      data={chartData.filter(d => d.name !== "Total" && d.name !== "Open" && d.value > 0)}
      dataKey="value"
      nameKey="name"
      cx="45%"
      cy="50%"
      outerRadius={100}
    >
      {chartData
        .filter(d => d.name !== "Total" && d.name !== "Open" && d.value > 0)
        .map((entry, index) => (
          <Cell key={`cell-${index}`} fill={chartColorMap[entry.name]} />
        ))}
    </Pie>
  </PieChart>
)}

                    {/*   AREA */}
                    {chartType === "area" && (
                      <AreaChart data={chartData} margin={{ top: 10, right: 40, left: 10, bottom: 10 }}>
                        <CartesianGrid vertical={false} stroke="#e5e7eb" />
                        <XAxis
                          dataKey="name"
                          interval={0}
                          angle={-20}
                          textAnchor="end"
                          height={50}
                        />
                        <YAxis />
                        <Tooltip content={<CustomTooltip />} />
                        <Area type="monotone" dataKey="value" stroke="#3b82f6" fill="#93c5fd" />
                      </AreaChart>
                    )}

                  </ResponsiveContainer>
                </div>
              </div>
            )}

            {viewType === "table" && (
              <div style={styles.tableContainer}>

                <div className="table-responsive">
                  <table style={styles.erpTable}>

                    {/* HEADER */}
                    <thead>
                      <tr>
                        <th
                          style={{
                            ...tableHeaderStyle,
                            background: "#f5f6fa",
                            padding: "10px",
                            borderBottom: "1px solid #ddd"
                          }}
                        >SO ID</th>
                        <th
                          style={{
                            ...tableHeaderStyle,
                            background: "#f5f6fa",
                            padding: "10px",
                            borderBottom: "1px solid #ddd"
                          }}
                        >Sales Organisation</th>
                        <th
                          style={{
                            ...tableHeaderStyle,
                            background: "#f5f6fa",
                            padding: "10px",
                            borderBottom: "1px solid #ddd"
                          }}
                        >Customer Segment</th>
                        <th
                          style={{
                            ...tableHeaderStyle,
                            background: "#f5f6fa",
                            padding: "10px",
                            borderBottom: "1px solid #ddd"
                          }}
                        >Customer</th>
                        <th
                          style={{
                            ...tableHeaderStyle,
                            background: "#f5f6fa",
                            padding: "10px",
                            borderBottom: "1px solid #ddd"
                          }}
                        >Distribution Channel</th>
                        <th
                          style={{
                            ...tableHeaderStyle,
                            background: "#f5f6fa",
                            padding: "10px",
                            borderBottom: "1px solid #ddd"
                          }}
                        >Status</th>
                        <th
                          style={{
                            ...tableHeaderStyle,
                            background: "#f5f6fa",
                            padding: "10px",
                            borderBottom: "1px solid #ddd",
                            textAlign: "right"
                          }}
                        >Total Net Price</th>
                      </tr>
                    </thead>

                    <tbody>
                      {tableData.length ? (
                        currentRows.map((row, i) => (
                          <tr key={i}>

                            <td
                              style={{
                                ...tableCellStyle,
                                padding: "10px",
                                borderBottom: "1px solid #eee",
                                color: "#2563eb",
                                cursor: "pointer",
                                fontWeight: 500
                              }}
                              onClick={() =>
                                navigate("/cable/sales/sales-order", {
                                  state: {
                                    soId: row.so_id,
                                    returnTo: "/cable/sales/sales-order-dashboard"
                                  }
                                })
                              }
                            >
                              {row.so_id}
                            </td>

                            <td
                              style={{
                                ...tableCellStyle,
                                padding: "10px",
                                borderBottom: "1px solid #eee"
                              }}
                            >{row.sales_organization}</td>
                            <td
                              style={{
                                ...tableCellStyle,
                                padding: "10px",
                                borderBottom: "1px solid #eee"
                              }}
                            >{row.customer_segment || "-"}</td>
                            <td
                              style={{
                                ...tableCellStyle,
                                padding: "10px",
                                borderBottom: "1px solid #eee"
                              }}
                            >{row.customer}</td>
                            <td
                              style={{
                                ...tableCellStyle,
                                padding: "10px",
                                borderBottom: "1px solid #eee"
                              }}
                            >{row.distribution_channel}</td>
                            <td
                              style={{
                                ...tableCellStyle,
                                padding: "10px",
                                borderBottom: "1px solid #eee"
                              }}
                            >{row.so_status}</td>

                            <td style={{
                              ...tableCellStyle,
                              padding: "10px",
                              borderBottom: "1px solid #eee",
                              textAlign: "right",
                              fontWeight: 500
                            }}>
                              ₹ {formatCurrency(row.net_price_after_discount)}
                            </td>

                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="7" style={{ textAlign: "center", padding: 12, color: "#64748b" }}>
                            No Records Found
                          </td>
                        </tr>
                      )}
                    </tbody>

                  </table>
                  <div className="d-flex justify-content-between align-items-center mt-3">

                    <div style={{ fontSize: "13px", color: "#64748b" }}>
                      Page <b>{currentPage}</b> of <b>{totalPages || 1}</b>
                    </div>

                    <div className="d-flex gap-2">
                      <button
                        className="btn btn-outline-secondary btn-sm"
                        disabled={currentPage === 1}
                        onClick={() => setCurrentPage(prev => prev - 1)}
                      >
                        Prev
                      </button>

                      <button
                        className="btn btn-outline-secondary btn-sm"
                        disabled={currentPage === totalPages || totalPages === 0}
                        onClick={() => setCurrentPage(prev => prev + 1)}
                      >
                        Next
                      </button>
                    </div>

                  </div>
                </div>

              </div>
            )}
          </div>
        </div>
      </div>

      {toast.show && (
        <div style={{
          position: "fixed", top: "20px", right: "20px", background: toast.type === "error" ? "#dc2626" : "#16a34a", color: "#fff", padding: "12px 20px",
          borderRadius: "8px", boxShadow: "0 10px 20px rgba(0,0,0,0.2)", zIndex: 10000, fontSize: "14px", minWidth: "250px"
        }}>
          {toast.message}
        </div>
      )}
    </Layout>
  );
};

export default SalesOrderDashboard;